import { useUIStore } from '@/config/stores/ui-store';
import { chatEE } from '@/layout';
import { Authorize } from '@/shared/components/authorize';
import { ArrowBack, Close, Settings } from '@mui/icons-material';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { Conversation } from '../../models/conversation';
import { PERMISSION_KEYS } from '../../models/permission';

export interface ConversationAsideHeaderProps {
  open: boolean;
  conversation: Conversation;
  headerTitle?: string;
}

const ConversationAsideHeader: FC<ConversationAsideHeaderProps> = ({ open, conversation, headerTitle }) => {
  const { t } = useTranslation();
  const { toggleAside } = useUIStore();

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '4rem',
        alignItems: 'center',
        borderBottom: 1,
        borderColor: 'divider',
        justifyContent: { xs: open ? 'flex-start' : 'center', md: 'flex-start' },
        px: { xs: open ? 2 : 1, md: 2 }
      }}
    >
      <Stack direction='row' alignItems='center' justifyContent={open ? 'space-between' : 'center'} flex={1}>
        <Stack direction='row' flex={1} flexDirection='row' alignItems='center' gap={1}>
          {headerTitle ? (
            <IconButton
              onClick={() => {
                chatEE.emit('aside-back-to-info');
              }}
            >
              <ArrowBack />
            </IconButton>
          ) : (
            <IconButton onClick={toggleAside}>
              <Close />
            </IconButton>
          )}

          <Typography variant='h6' noWrap sx={{ display: 'flex', flex: 1, px: 1, textAlign: 'center' }}>
            {headerTitle || t('conversations.aside.info')}
          </Typography>

          <Authorize conversationId={conversation.conversationId!} permissions={[PERMISSION_KEYS.CONVERSATION_UPDATE]}>
            <IconButton
              onClick={() => {
                chatEE.emit('open-group-settings', conversation);
              }}
              sx={{ borderRadius: '2px' }}
            >
              <Settings sx={{ color: 'text.secondary' }} />
            </IconButton>
          </Authorize>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ConversationAsideHeader;
